(function() {
  'use strict';

  angular.module('blocks.versions', []);
})();
